import BACK_IMAGE from '@/assets/images/weee-icon-return.png';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import { WeeeIcon } from '@/components/common/Icon';
import Img from '@/components/common/Img';

import MiniCart from '@/components/common/MiniCartIcon';
import LazySearch from '@/components/common/SearchOverlay/LazySearch';

type CateHeaderProps = {
  isHorizontal: boolean;
  switchCb?: () => void;
  showBackBtn?: boolean;
  onBack?: () => void;
  isMkpl?: boolean;
  isPreload?: boolean;
};

function CateHeader(props: CateHeaderProps) {
  const { t } = useTranslation('common');
  const router = useRouter();
  const handleSearch = (keyword, type) => {
    if (props?.isMkpl) {
      type
        ? router.push(`/mkpl/search?keyword=${keyword}&trigger_type=${type}`)
        : router.push(`/mkpl/search?keyword=${keyword}`);
      return;
    }
    type
      ? router.push(`/search?keyword=${keyword}&trigger_type=${type}&from=hotkeyword`)
      : router.push(`/search?keyword=${keyword}&from=hotkeyword`);
  };

  return (
    <div className="w-full h-12 bg-surface-100-bg z-[500]">
      <div id="cate-header" className="w-full h-full box-border flex items-center px-4 py-0 bg-surface-100-bg">
        {props?.showBackBtn && (
          <>
            <Img
              className="w-6 h-6 cursor-pointer object-contain mr-2.5"
              src={BACK_IMAGE}
              onClick={() => {
                props?.onBack();
              }}
            />
          </>
        )}

        <div
          style={{
            boxShadow: '0px 9px 20px rgba(0, 0, 0, 0.07), 0px 1px 8px rgba(0, 0, 0, 0.04)'
          }}
          className="box-border grow flex items-center py-2.5 pl-4 pr-1 h-10 divide-surface-100-bg text-input-200-hairline-default rounded-full border border-solid border-surface-300-bg mr-2">
          <div className="w-3.5 h-3.5 flex items-center justify-center text-surface-100-fg-default [&_.icon]:text-[16px] mr-1.5">
            <WeeeIcon type="iconcategory_select" />
          </div>
          <LazySearch
            isTriggerType={true}
            onSearch={handleSearch}
            isSupportAssoation={!props?.isMkpl}
            isSupportBought={!props?.isMkpl}
            isSupportHotKeyword={!props?.isMkpl}
            isPreload={props.isPreload}
            moduleName={props?.isMkpl ? 'global' : ''}>
            <div className="w-full">
              <div className="text-surface-100-fg-minor enki-body-sm-medium">{t('search_placeholder1')}</div>
            </div>
          </LazySearch>
        </div>
        <MiniCart className="text-primary-1" />
      </div>
    </div>
  );
}

export default CateHeader;
